
import ws from "@/views/productBrand/ws";
import Add from "@/views/productBrand/Add";
import List from "@/views/productBrand/List";
import Edit from "@/views/productBrand/Edit";
import ManagePage from "@/views/ProductAttribute/ManagePage";
import ProductAttributeAdd from "@/views/ProductAttribute/ProductAttributeAdd";
import ProductAttributeEdit from "@/views/ProductAttribute/ProductAttributeEdit";
import AddProductCategory from "@/views/productCategory/AddProductCategory";
import ProductCategoryList from "@/views/productCategory/ProductCategoryList";
import ProductCategoryEdit from "@/views/productCategory/ProductCategoryEdit";
import ProductAdd from "@/views/product/ProductAdd";
import ProductList from "@/views/product/ProductList";
import ProductEdit from "@/views/product/ProductEdit";
import deleteCategory from "@/views/productCategory/deleteCategory";

const routes = [
  {
    path: '/ws',
    name: 'ws',
    component: ws,
    meta:{requiredAuth:true}
  },
  {
    path: '/ProductBrand/Add',
    name: 'AddProductBrand',
    component: Add,
    meta:{requiredAuth:true}
  },
  {
    path: '/ProductBrand/List',
    name: 'ListProductBrand',
    component: List,
    meta:{requiredAuth:true}
  },{
    path: '/ProductBrand/Edit/:id',
    name: 'EditProductBrand',
    component: Edit,
    meta:{requiredAuth:true}
  },{
    path: '/ProductAttribute/Manage',
    name: 'ProductAttributeManage',
    component: ManagePage,
    meta:{requiredAuth:true}
  },{
    path: '/ProductAttribute/Add',
    name: 'ProductAttributeAdd',
    component: ProductAttributeAdd,
    meta:{requiredAuth:true}
  },{
    path: '/ProductAttribute/Edit/:id',
    name: 'ProductAttributeEdit',
    component: ProductAttributeEdit,
    meta:{requiredAuth:true}
  },{
    path: '/ProductCategory/Add',
    name: 'AddProductCategory',
    component: AddProductCategory,
    meta:{requiredAuth:true}
  },{
    path: '/ProductCategory/List',
    name: 'ProductCategoryList',
    component: ProductCategoryList,
    meta:{requiredAuth:true}
  },{
    path: '/ProductCategory/Edit/:id',
    name: 'ProductCategoryEdit',
    component: ProductCategoryEdit,
    meta:{requiredAuth:true}
  },{
    path: '/productCategory/delete/:id',
    name: 'deleteCategory',
    component: deleteCategory,
    meta:{requiredAuth:true}
  },
  {
    path: '/Product/Add',
    name: 'ProductAdd',
    component: ProductAdd,
    meta:{requiredAuth:true}
  },
  {
    path: '/Product/List',
    name: 'ProductList',
    component: ProductList,
    meta:{requiredAuth:true}
  },
  {
    path: '/Product/Edit/:id',
    name: 'ProductEdit',
    component: ProductEdit,
    meta:{requiredAuth:true}
  }
]

export default routes
